import { Banner } from "@astryxdesign/core/Banner";
import { Button } from "@astryxdesign/core/Button";

interface RetryBannerProps {
  title: string;
  description?: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

// Every management page's error state used to be a bare `Banner` with no way
// forward except switching tabs — the query itself already supports refetch,
// nothing surfaced it. This is that fix, applied once: an error banner that
// always offers the one obvious next action.
export function RetryBanner({ title, description, onRetry, isRetrying }: RetryBannerProps) {
  return (
    <Banner
      status="error"
      title={title}
      description={description}
      endContent={<Button label="Retry" variant="secondary" size="sm" onClick={onRetry} isLoading={isRetrying} />}
    />
  );
}
